export const validateUserForm = (
    formData,
    editingUser
  ) => {
    const errors = {};
  
    if (!formData.name?.trim()) {
      errors.name =
        "Tên không được để trống";
    }
  
    if (!editingUser) {
      if (!formData.email?.trim()) {
        errors.email =
          "Email không được để trống";
      } else if (
        !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(
          formData.email
        )
      ) {
        errors.email =
          "Email không hợp lệ";
      }
    }
  
    if (
      !editingUser ||
      formData.password
    ) {
      if (
        !formData.password ||
        formData.password.length < 6
      ) {
        errors.password =
          "Mật khẩu phải từ 6 ký tự trở lên";
      }
    }
  
    if (!formData.phone?.trim()) {
      errors.phone =
        "Số điện thoại không được để trống";
    } else if (
      !/^\d{10,15}$/.test(formData.phone)
    ) {
      errors.phone =
        "Số điện thoại không hợp lệ";
    }
  
    if (
      ![
        "admin",
        "staff",
        "users",
      ].includes(formData.role)
    ) {
      errors.role =
        "Vai trò không hợp lệ";
    }
  
    return errors;
  };